import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import {
  Container,
  Dropdown,
  Form,
  FormDropdown,
  Header,
  Input,
  Label,
  Segment,
} from 'semantic-ui-react';
import cx from 'classnames';
import CleanableDatepicker from 'common/components/CleanableDatepicker';
import Timepicker from 'common/components/Timepicker';
import { getTimeUnits, getWorkers } from '../reducers/requirements';
import { fetchRequirements } from '../actions/requirements';
import {
  getInterventionDate,
  getInterventionTime,
  getPreInterventionDate,
  getPrimaryWorkerId,
  getSecondaryWorkerIds,
  getVisitDuration,
  getVisitDurationUnit,
  getBuildingSurface,
  getGroundSurface,
  getErrors,
} from '../reducers/form';
import {
  updateDuration,
  updateDurationUnit,
  updateInterventionDate,
  updateInterventionTime,
  updatePreplanningDate,
  updateSecondaryWorkerIds,
  updateWorkerId,
  updateBuildingSurface,
  updateGroundSurface,
  fetchFormIfNeeded,
} from '../actions/form';
import PreplannificationInput from '../../../common/components/PreplannificationInput';
import { unmountComponentAtNode } from 'react-dom';

const mapStateToProps = (state, ownProps) => ({
  timeUnits: getTimeUnits(state),
  workers: getWorkers(state),
  visitDuration: getVisitDuration(state),
  visitDurationUnit: getVisitDurationUnit(state),
  interventionDate: getInterventionDate(state),
  interventionTime: getInterventionTime(state),
  preInterventionDate: getPreInterventionDate(state),
  workerId: getPrimaryWorkerId(state),
  secondaryWorkerIds: getSecondaryWorkerIds(state),
  buildingSurface: getBuildingSurface(state),
  groundSurface: getGroundSurface(state),
  errors: getErrors(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: caseId => dispatch(fetchFormIfNeeded(caseId)),
  fetchRequirements: () => dispatch(fetchRequirements(ownProps.id)),
  updatePlanningDate: date => dispatch(updateInterventionDate(date)),
  updatePlanningTime: time => dispatch(updateInterventionTime(time)),
  updateVisitDuration: duration =>
    dispatch(updateDuration(parseInt(duration, 10))),
  updateVisitDurationUnit: unit => dispatch(updateDurationUnit(unit)),
  updatePreplanningDate: date => dispatch(updatePreplanningDate(date)),
  updateWorkerId: id => dispatch(updateWorkerId(id)),
  updateSecondaryWorkerIds: ids => dispatch(updateSecondaryWorkerIds(ids)),
  updateBuildingSurface: evt => {
    if (![null, '', false].includes(evt.target.value)) {
      dispatch(updateBuildingSurface(parseInt(evt.target.value, 10)));
    } else dispatch(updateBuildingSurface(null));
  },
  updateGroundSurface: evt => {
    if (![null, '', false].includes(evt.target.value)) {
      dispatch(updateGroundSurface(parseInt(evt.target.value, 10)));
    } else dispatch(updateGroundSurface(null));
  },
});

export class Page extends React.Component {
  constructor(props) {
    super(props);

    this._renderPrimaryWorkersOptions = this._renderPrimaryWorkersOptions.bind(
      this
    );
  }

  componentWillMount() {
    this.props.fetchRequirements();
    this.props.fetchForm(this.props.id);
  }

  closeModal() {
    unmountComponentAtNode(document.getElementById('modal-root')); // ensure that reopening will fetch form again
  }

  _renderPrimaryWorkersOptions() {
    return this.props.workers.map(w => ({
      key: w.id,
      text: w.display_name,
      value: w.id,
    }));
  }

  _renderSecondaryWorkersOptions() {
    return this.props.workers
      .filter(
        w => this.props.workerId === undefined || this.props.workers !== w.id
      )
      .map(w => ({
        key: w.id,
        text: w.display_name,
        value: w.id,
      }));
  }

  render() {
    const {
      timeUnits,
      visitDuration,
      visitDurationUnit,
      interventionDate,
      interventionTime,
      preInterventionDate,
      workerId,
      secondaryWorkerIds,
      buildingSurface,
      groundSurface,
      errors,
    } = this.props;
    const fieldClass = fieldName =>
      cx('field required', {
        error: errors.includes(fieldName),
      });

    return (
      <Form>
        <Segment>
          <Header as="h3">
            1- Confirmer la date de la prochaine intervention
          </Header>
          <Form.Group>
            <Form.Field
              width={8}
              required
              error={
                errors.includes('interventionDate') ||
                errors.includes('preInterventionDate')
              }
            >
              <label>Date ou semaine</label>
              <Form.Group>
                <Form.Field width={6}>
                  <CleanableDatepicker
                    identifier="interventionDate"
                    name="interventionDate"
                    value={interventionDate || ''}
                    onChange={this.props.updatePlanningDate}
                    placeholder="JJ/MM/AAAA"
                    required
                  />
                </Form.Field>
                <Form.Field width={3}>
                  <Timepicker
                    name="interventionTime"
                    value={interventionTime || ''}
                    onChange={this.props.updatePlanningTime}
                  />
                </Form.Field>
                <Form.Field width={1} style={{ paddingTop: '7px' }}>
                  <Label circular color="grey">
                    ou
                  </Label>
                </Form.Field>
                <Form.Field width={6}>
                  <PreplannificationInput
                    name="preInterventionDate"
                    value={preInterventionDate || ''}
                    onChange={this.props.updatePreplanningDate}
                    placeholder="Semaine"
                  />
                </Form.Field>
              </Form.Group>
            </Form.Field>
            <Form.Field width={8}>
              <label>Durée de l'intervention</label>
              <Input
                value={visitDuration || ''}
                type="number"
                label={
                  <Dropdown
                    value={visitDurationUnit || 176}
                    options={timeUnits.map(tu => ({
                      key: tu.id,
                      text: tu.label,
                      value: tu.id,
                    }))}
                    basic
                    onChange={(_, value) =>
                      this.props.updateVisitDurationUnit(value.value)
                    }
                  />
                }
                labelPosition="right"
                placeholder="Durée"
                onChange={(_, value) =>
                  this.props.updateVisitDuration(value.value)
                }
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <FormDropdown
              className={fieldClass('primaryWorkerId')}
              label="Commercial"
              selection
              options={this._renderPrimaryWorkersOptions()}
              value={workerId}
              onChange={(_, value) => this.props.updateWorkerId(value.value)}
              width={5}
            />
            <FormDropdown
              label="Techniciens secondaires"
              selection
              multiple
              options={this._renderSecondaryWorkersOptions()}
              value={secondaryWorkerIds}
              onChange={(_, value) =>
                this.props.updateSecondaryWorkerIds(value.value)
              }
              width={11}
            />
          </Form.Group>
        </Segment>
        <Segment>
          <Header as="h3">
            2- Confirmer ou renseigner la superficie du chantier
          </Header>
          <Form.Group>
            <Form.Field width={8} className={fieldClass('buildingSurface')}>
              <label>M² bâti </label>
              <Input
                value={buildingSurface}
                type="text"
                onChange={this.props.updateBuildingSurface}
              />
            </Form.Field>
            <Form.Field
              width={8}
              required
              className={fieldClass('groundSurface')}
            >
              <label>M² terrain </label>
              <Input
                value={groundSurface}
                type="text"
                onChange={this.props.updateGroundSurface}
              />
            </Form.Field>
          </Form.Group>
        </Segment>
        <Segment>
          <Container textAlign="right">
            <div className="actions">
              <div className="ui primary button" id="bt-confirm-contract">
                Confirmer
              </div>
              <div
                className="ui cancel button"
                onClick={() => this.closeModal()}
              >
                Annuler
              </div>
            </div>
          </Container>
        </Segment>
      </Form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  timeUnits: PropTypes.array.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
  updatePlanningDate: PropTypes.func.isRequired,
  updatePlanningTime: PropTypes.func.isRequired,
  updateVisitDuration: PropTypes.func.isRequired,
  updateVisitDurationUnit: PropTypes.func.isRequired,
  updatePreplanningDate: PropTypes.func.isRequired,
  updateWorkerId: PropTypes.func.isRequired,
  updateSecondaryWorkerIds: PropTypes.func.isRequired,
  fetchForm: PropTypes.func.isRequired,
  visitDuration: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/components/AcceptContractModal.js